import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { BaseInput, BaseDeleteButton, BaseAddNewButton, RichTextEditor } from './index';
import { HANDLE_ADD_DELETE_OVERVIEW_SECTION, HANDLE_OVERVIEW_SECTION } from '../store/modules/course';
import './css/course-overview.scss';

export const CourseOverview = function () {
    const dispatch = useDispatch();
    const { overview } = useSelector((state) => state.course.data);

    useEffect(() => {
        !overview?.length && handleAddDeleteSection('add');
    }, []);

    function handleInput(payload) {
        dispatch(HANDLE_OVERVIEW_SECTION(payload));
    }

    function handleAddDeleteSection(action) {
        dispatch(HANDLE_ADD_DELETE_OVERVIEW_SECTION(action));
    }

    return (
        <section id="authors" cy="course-overview" className="course-overview">
            <h2>Overview</h2>
            {overview?.map(({ title, description }, index) => (
                <div className="author-group" cy="author-group" key={index}>
                    <h3>{`Section ${index + 1}`}</h3>
                    <BaseInput
                        name={`title${index + 1}`}
                        label="Title"
                        value={title}
                        onInput={({ value }) => handleInput({ key: 'title', value, index })}
                    />
                    <RichTextEditor
                        title="Description"
                        name="description"
                        value={description}
                        onChange={(obj) => handleInput({ key: 'description', ...obj, index })}
                        large
                        toolbar={['bold','italic','underline','strike',{ script: 'super' },{ script: 'sub' },{ list: 'ordered' },{ list: 'bullet' },'link']}
                    />
                </div>
            ))}
            <div className="flex flex-between">
                <BaseAddNewButton
                    text="Add another section"
                    cy="add-new-section"
                    onClick={() => handleAddDeleteSection('add')}
                />
                <BaseDeleteButton
                    text="Delete last section"
                    onClick={() => handleAddDeleteSection('delete')}
                />
            </div>
        </section>
    );
};
